(function () {
  'use strict';

  var AVATAR =
    'https://cdn.shopify.com/s/files/1/0721/6644/1241/files/ChatGPT_Image_Jun_27_2026_05_15_47_PM.png?v=1782594985';
  var ROOT_ID = 'ejsSvcBookingRoot';
  var CONFIG_ID = 'ejsSvcBookingConfig';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function emptyDraft() {
    return {
      service: null,
      category: null,
      device: null,
      details: null,
      date: null,
      time: null,
      name: null,
      email: null,
      phone: null,
    };
  }

  ready(function init() {
    var root = document.getElementById(ROOT_ID);
    var configEl = document.getElementById(CONFIG_ID);
    if (!root || !configEl) return;

    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      console.error('[Wattson] Invalid booking config', error);
      return;
    }

    var lang = String(cfg.lang || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
    var fr = lang === 'fr';
    var msgsEl = document.getElementById('ejsSbkMsgs');
    var typingEl = document.getElementById('ejsSbkTyping');
    var inputEl = document.getElementById('ejsSbkInput');
    var sendBtn = document.getElementById('ejsSbkSend');
    var micBtn = document.getElementById('ejsSbkMic');
    var resetBtn = document.getElementById('ejsSbkReset');
    if (!msgsEl || !typingEl || !inputEl || !sendBtn) return;

    var messages = [];
    var draft = emptyDraft();
    var busy = false;
    var booked = false;
    var laptopOffered = false;
    var voiceHintShown = false;
    var listening = false;
    var recognition = null;
    var spoken = '';
    var voiceRestartTimer = null;
    var voiceLangIndex = 0;
    var voiceRapidEnds = 0;
    var voiceStartedAt = 0;
    var quickEl = null;
    var panelEl = null;
    var summarySlot = document.getElementById('ejsSbkSummary');

    var copy = fr
      ? {
          greet:
            'Bonjour, je suis Wattson. Dites-moi le service dont vous avez besoin, ou choisissez-le dans la liste. Je vous poserai ensuite les questions pour bien comprendre votre besoin, jusqu’au rendez-vous.',
          placeholder: 'Nommez le service, ou décrivez votre besoin…',
          voiceHint: 'Vous pouvez aussi cliquer sur le microphone à côté du bouton d’envoi pour laisser un message vocal.',
          voiceListening: 'Je vous écoute… Cliquez de nouveau pour envoyer.',
          voiceDenied: 'Le micro est bloqué. Vous pouvez écrire votre message.',
          voiceUnsupported: 'Le message vocal n’est pas disponible dans ce navigateur. Vous pouvez écrire votre message.',
          voiceNoDevice: 'Je ne trouve pas de micro. Vous pouvez écrire votre message.',
          voiceNetwork: 'Le message vocal n’a pas abouti. Vous pouvez écrire votre message, ou réessayer.',
          sent: 'Votre demande est déjà notée. Si vous voulez un autre rendez-vous, dites-le-moi.',
          network: 'Je n’arrive pas à joindre le serveur. Réessayez dans un instant.',
          choose: 'Je choisis',
          more: 'Autres heures',
          moreMsg: 'Montre-moi d’autres heures.',
          today: 'Aujourd’hui',
          tomorrow: 'Demain',
          thisWeek: 'Cette semaine',
          nextWeek: 'Semaine prochaine',
          morning: 'Matin',
          afternoon: 'Après-midi',
          anytime: 'Peu importe',
          anotherDay: 'Essayer un autre jour',
          dayChosen: 'D\u2019accord, {day}. Vous pr\u00e9f\u00e9rez le matin, l\u2019apr\u00e8s-midi, ou peu importe?',
          timeChosen: 'D\u2019accord. Choisissez une heure.',
          otherDay: 'D\u2019accord, on choisit un autre jour.',
          noSlots: 'Je ne vois aucune plage pour ce choix. Essayez un autre jour.',
          contact: 'Pour réserver, j’ai besoin de vos coordonnées.',
          fillForm: 'Veuillez remplir le court formulaire ci-dessous pour voir le sommaire et prendre rendez-vous.',
          first: 'Prénom',
          last: 'Nom',
          email: 'Courriel',
          phone: 'Téléphone',
          hintFirst: 'Jean',
          hintLast: 'Tremblay',
          hintEmail: 'jean@email.com',
          hintPhone: '450 555-1234',
          hintNote: 'Écran noir, lent au démarrage',
          continue: 'Continuer',
          confirm: 'Confirmer le rendez-vous',
          confirmMsg: 'Je confirme ce rendez-vous.',
          summaryTitle: 'Votre demande de rendez-vous est presque prête.',
          summaryNote: 'Veuillez vérifier les informations ci-dessous avant de soumettre votre demande.',
          summaryPrompt: 'Voici votre résumé. Quand vous êtes prêt, soumettez votre demande de rendez-vous.',
          summaryCategory: 'Catégorie',
          summaryService: 'Service',
          summaryDevice: 'Appareil',
          summaryDetails: 'Détails',
          summaryAppointmentType: 'Type de rendez-vous',
          summaryDate: 'Date',
          summaryTime: 'Heure',
          summaryName: 'Nom',
          summaryEmail: 'Courriel',
          summaryPhone: 'Téléphone',
          summaryEstimatedPrice: 'Prix estimé',
          summaryNa: 'N/D',
          dropOff: 'Dépôt en magasin',
          requestAppointment: 'Demander un rendez-vous',
          requesting: 'Envoi en cours…',
          appointmentRequested: 'Demande envoyée',
          quoteOnInspection: 'Devis sur inspection',
          priceNote1: 'Le prix final peut varier selon le diagnostic, la disponibilité des pièces et le problème exact.',
          priceNote2: 'Si des pièces doivent être commandées, nous vous contacterons d\u2019abord avec le prix avant de continuer.',
          priceNote3: 'Aucun travail n\u2019est effectué sans votre confirmation. Aucuns frais cachés.',
          priceNote4: 'Aucun paiement n\u2019est requis aujourd\u2019hui. Le paiement se fait après le service, en argent comptant ou par virement Interac.',
          successBoth: 'Parfait.\n\nVotre demande de rendez-vous a été reçue.\n\nUn courriel de confirmation vous a été envoyé et le rendez-vous a été ajouté à notre calendrier. Si vous ne le voyez pas, vérifiez vos pourriels.\n\nNous examinerons votre demande et vous contacterons si un ajustement est nécessaire.',
          slotOk: 'D\u2019accord, {when}.',
          successCalendar: 'Parfait.\n\nVotre demande de rendez-vous a été reçue et ajoutée à notre calendrier.\n\nNous n\u2019avons pas pu envoyer automatiquement le courriel de confirmation, mais nous vous contacterons sous peu.',
          missing: 'Remplissez tous les champs.',
          badEmail: 'Ce courriel n\u2019est pas valide.',
          badPhone: 'Ce num\u00e9ro de t\u00e9l\u00e9phone n\u2019est pas valide.',
          missingField: 'Remplissez ce champ.',
          service: 'Je veux un rendez-vous pour : ',
          deviceAsk: 'D\u2019accord. C\u2019est pour un ordinateur de bureau ou un portable?',
          desktop: 'Ordinateur de bureau',
          desktopMsg: 'C\u2019est un ordinateur de bureau.',
          laptop: 'Portable',
          laptopMsg: 'C\u2019est un portable.',
          laptopNo:
            'Malheureusement, nous ne r\u00e9parons pas les ordinateurs portables. Nous ne faisons que des ordinateurs de bureau.',
          laptopNext:
            'Si vous avez un ordinateur de bureau, on peut continuer. Sinon, laissez vos coordonn\u00e9es et on vous recontacte pour vous orienter.',
          desktopInstead: 'J\u2019ai un ordinateur de bureau',
          leaveInfo: 'Me laisser un message',
          note: 'Le probl\u00e8me, en bref',
          leadSend: 'Envoyer',
          leadThanks: 'C\u2019est not\u00e9. On vous recontacte bient\u00f4t pour vous orienter.',
          leadFail: 'Je n\u2019ai pas pu envoyer \u00e7a. \u00c9crivez-nous \u00e0 info@ejscomputers.com.',
          contactForm: 'Formulaire de contact',
        }
      : {
          greet:
            "Hi, I'm Wattson. Tell me which service you need, or choose one from the list. I'll ask what I need to understand the job, right through to the appointment.",
          placeholder: 'Name the service, or describe what you need…',
          voiceHint: 'You can also click the microphone next to the send button to leave a voice message.',
          voiceListening: 'Listening… Click again to send.',
          voiceDenied: 'The microphone is blocked. You can type your message instead.',
          voiceUnsupported: 'Voice messages are not available in this browser. You can type your message instead.',
          voiceNoDevice: 'I cannot find a microphone. You can type your message instead.',
          voiceNetwork: 'The voice message did not go through. You can type your message, or try again.',
          sent: 'Your request is already noted. If you want another appointment, just tell me.',
          network: 'I cannot reach the server. Try again in a moment.',
          choose: 'I choose',
          more: 'More times',
          moreMsg: 'Show me more times.',
          today: 'Today',
          tomorrow: 'Tomorrow',
          thisWeek: 'This week',
          nextWeek: 'Next week',
          morning: 'Morning',
          afternoon: 'Afternoon',
          anytime: 'Anytime',
          anotherDay: 'Try another day',
          dayChosen: 'All right, {day}. Morning, afternoon, or either?',
          timeChosen: 'All right. Choose a time.',
          otherDay: 'All right, let us pick another day.',
          noSlots: 'I do not see any openings for that choice. Try another day.',
          contact: 'To book this, I need your contact details.',
          fillForm: 'Please fill in the short form below to see the summary and book your appointment.',
          first: 'First name',
          last: 'Last name',
          email: 'Email',
          phone: 'Phone',
          hintFirst: 'Alex',
          hintLast: 'Smith',
          hintEmail: 'alex@email.com',
          hintPhone: '450 555-1234',
          hintNote: 'Black screen, slow to start',
          continue: 'Continue',
          confirm: 'Confirm appointment',
          confirmMsg: 'I confirm this appointment.',
          summaryTitle: 'Your appointment request is almost ready.',
          summaryNote: 'Please review everything below before submitting your appointment request.',
          summaryPrompt: "Here's your summary. When you're ready, submit your appointment request.",
          summaryCategory: 'Category',
          summaryService: 'Service',
          summaryDevice: 'Device',
          summaryDetails: 'Details',
          summaryAppointmentType: 'Appointment type',
          summaryDate: 'Date',
          summaryTime: 'Time',
          summaryName: 'Name',
          summaryEmail: 'Email',
          summaryPhone: 'Phone',
          summaryEstimatedPrice: 'Estimated price',
          summaryNa: 'N/A',
          dropOff: 'Drop-off',
          requestAppointment: 'Request appointment',
          requesting: 'Sending…',
          appointmentRequested: 'Request sent',
          quoteOnInspection: 'Quote on inspection',
          priceNote1: 'Final pricing may vary depending on diagnostics and required replacement parts.',
          priceNote2: 'If parts need to be ordered, we will contact you first with the price before proceeding.',
          priceNote3: 'No work is performed without your confirmation. No hidden fees.',
          priceNote4: 'No payment is required today. Payment is made after the service, by cash or Interac e-Transfer.',
          successBoth: "Perfect.\n\nYour appointment request has been received.\n\nA confirmation email has been sent, and the appointment has been added to our calendar. If you do not see it, check your spam folder.\n\nWe'll review your request and contact you if anything needs to be adjusted.",
          slotOk: 'All right, {when}.',
          successCalendar: 'Perfect.\n\nYour appointment request has been received and added to our calendar.\n\nWe could not automatically send the confirmation email, but we will contact you shortly.',
          missing: 'Fill in every field.',
          badEmail: 'That email is not valid.',
          badPhone: 'That phone number is not valid.',
          missingField: 'Fill in this field.',
          service: 'I want an appointment for: ',
          deviceAsk: 'All right. Is this for a desktop PC or a laptop?',
          desktop: 'Desktop PC',
          desktopMsg: 'It is a desktop PC.',
          laptop: 'Laptop',
          laptopMsg: 'It is a laptop.',
          laptopNo: 'Unfortunately, we do not work on laptops. We only service desktop PCs.',
          laptopNext:
            'If you have a desktop PC, we can continue. Otherwise, leave your details and we will get back to you with somewhere to go.',
          desktopInstead: 'I have a desktop PC',
          leaveInfo: 'Leave a message',
          note: 'The problem, briefly',
          leadSend: 'Send',
          leadThanks: 'Noted. We will get back to you with somewhere to go.',
          leadFail: 'I could not send that. Write to us at info@ejscomputers.com.',
          contactForm: 'Contact form',
        };

    inputEl.placeholder = copy.placeholder;

    function apiUrl() {
      return String(cfg.bookingApiUrl || '').replace(/\/$/, '') + '/api/services/chat';
    }

    function esc(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function scroll() {
      msgsEl.scrollTop = msgsEl.scrollHeight;
    }

    function face() {
      return (
        '<div class="ejs-sbk-av ejs-sbk-av-ai" aria-hidden="true"><img src="' +
        AVATAR +
        '" alt="" width="28" height="28"></div>'
      );
    }

    function addMsg(role, text) {
      var wrap = document.createElement('div');
      wrap.className = 'ejs-sbk-msg ejs-sbk-msg-' + role;
      if (role === 'ai') {
        wrap.innerHTML = face() + '<div class="ejs-sbk-bubble ejs-sbk-bubble-ai">' + esc(text) + '</div>';
      } else {
        wrap.innerHTML =
          '<div class="ejs-sbk-av ejs-sbk-av-user"><span class="ejs-sbk-av-user-icon" aria-hidden="true">👤</span></div><div class="ejs-sbk-bubble ejs-sbk-bubble-user">' +
          esc(text) +
          '</div>';
      }
      msgsEl.insertBefore(wrap, typingEl);
      scroll();
    }

    function showTyping(on) {
      typingEl.classList.toggle('ejs-sbk-show', on);
      if (on) scroll();
    }

    function setEnabled(on) {
      inputEl.disabled = !on;
      sendBtn.disabled = !on;
      if (micBtn) micBtn.disabled = !on;
      if (on && !listening) inputEl.placeholder = copy.placeholder;
    }

    function setMicListening(on) {
      listening = on;
      if (!micBtn) return;
      micBtn.classList.toggle('ejs-sbk-mic-on', on);
      micBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!inputEl.disabled) inputEl.placeholder = on ? copy.voiceListening : copy.placeholder;
    }

    function clearVoiceTimer() {
      if (!voiceRestartTimer) return;
      window.clearTimeout(voiceRestartTimer);
      voiceRestartTimer = null;
    }

    function haltMic() {
      clearVoiceTimer();
      var rec = recognition;
      recognition = null;
      spoken = '';
      setMicListening(false);
      if (!rec) return;
      rec.onend = null;
      rec.onerror = null;
      rec.onresult = null;
      try { rec.abort(); } catch (err) {
        try { rec.stop(); } catch (err2) { /* already stopped */ }
      }
    }

    function keepSpokenText() {
      var kept = String(inputEl.value || spoken || '').trim();
      haltMic();
      if (kept) inputEl.value = kept;
      return kept;
    }

    function openRecognition(isRestart) {
      var SpeechRec = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRec) {
        haltMic();
        addMsg('ai', copy.voiceUnsupported);
        return;
      }
      var langs = fr ? ['fr-CA', 'fr-FR'] : ['en-CA', 'en-US'];
      var rec = new SpeechRec();
      recognition = rec;
      rec.lang = langs[Math.min(voiceLangIndex, langs.length - 1)];
      rec.interimResults = true;
      rec.continuous = true;
      var base = spoken;
      rec.onresult = function (event) {
        voiceRapidEnds = 0;
        var text = '';
        for (var i = 0; i < event.results.length; i++) text += event.results[i][0].transcript;
        spoken = (base + ' ' + text).trim();
        inputEl.value = spoken;
      };
      rec.onerror = function (event) {
        var code = event && event.error;
        if (code === 'no-speech' || code === 'aborted') return;
        if (code === 'not-allowed' || code === 'service-not-allowed') {
          haltMic();
          addMsg('ai', copy.voiceDenied);
          return;
        }
        if (code === 'audio-capture') {
          haltMic();
          addMsg('ai', copy.voiceNoDevice);
          return;
        }
        if (code === 'language-not-supported' && voiceLangIndex < langs.length - 1) {
          voiceLangIndex += 1;
          return;
        }
        if (code === 'network' || code === 'language-not-supported') {
          keepSpokenText();
          addMsg('ai', code === 'network' ? copy.voiceNetwork : copy.voiceUnsupported);
        }
      };
      rec.onend = function () {
        if (recognition !== rec || !listening) return;
        if (Date.now() - voiceStartedAt < 500) voiceRapidEnds += 1;
        else voiceRapidEnds = 0;
        if (voiceRapidEnds >= 3) {
          if (!keepSpokenText()) addMsg('ai', copy.voiceUnsupported);
          return;
        }
        voiceRestartTimer = window.setTimeout(function () {
          voiceRestartTimer = null;
          if (!listening || recognition !== rec) return;
          recognition = null;
          openRecognition(true);
        }, 200);
      };
      try {
        voiceStartedAt = Date.now();
        rec.start();
        setMicListening(true);
      } catch (err) {
        if (!keepSpokenText() && !isRestart) addMsg('ai', copy.voiceUnsupported);
      }
    }

    function startListening() {
      spoken = String(inputEl.value || '').trim();
      voiceLangIndex = 0;
      voiceRapidEnds = 0;
      openRecognition(false);
    }

    function needsVoiceHint() {
      if (voiceHintShown || booked || customerChoseLaptop()) return false;
      if (!draft.device) return false;
      if (draft.details && String(draft.details).length >= 8) return false;
      if (draft.date) return false;
      return true;
    }

    var serviceChoices = [
      {
        en: 'Assembly and diagnostics',
        fr: 'Assemblage et diagnostic',
        promptEn: 'All right. Which assembly or diagnostic do you need?',
        promptFr: 'D\u2019accord. Quel assemblage ou diagnostic vous int\u00e9resse?',
        services: [
          ['Computer Diagnostics', 'Diagnostic informatique'],
          ['Virus & Malware Removal', 'Suppression de virus et logiciels malveillants'],
          ['PC Assembly', "Assemblage d'un ordinateur"],
          ['PC Assembly with Liquid Cooler', 'Assemblage avec refroidisseur liquide'],
          ['PC Assembly Compact Case', 'Assemblage boîtier compact'],
          ['PC Assembly Compact Case with Liquid Cooler', 'Assemblage boîtier compact avec refroidisseur liquide'],
        ],
      },
      {
        en: 'Software Services',
        fr: 'Windows / Logiciels',
        promptEn: 'All right. Which Windows or software service do you need?',
        promptFr: 'D\u2019accord. Quel service Windows ou logiciel vous int\u00e9resse?',
        services: [
          ['Windows Installation', 'Installation de Windows'],
          ['Software Installation', 'Logiciels et pilotes', 'Software & Drivers'],
          ['BIOS Updates', 'Mises à jour du BIOS'],
          ['Windows Optimization', 'Optimisation de Windows'],
          ['Data Backup', 'Sauvegarde et transfert', 'Data Backup & Transfer'],
        ],
      },
      {
        en: 'Install and replacement',
        fr: 'Installation et remplacement',
        promptEn: 'All right. Which part do you want installed or replaced?',
        promptFr: 'D\u2019accord. Quelle pi\u00e8ce faut-il installer ou remplacer?',
        services: [
          ['SSD Upgrades', 'SSD / disque dur', 'SSD / Hard Drive'],
          ['RAM Upgrades', 'RAM', 'RAM'],
          ['CPU Upgrades', 'Processeur', 'Processor'],
          ['Graphics Card Installation', 'Carte graphique', 'Graphics Card'],
          ['CPU Cooler Replacement', 'Refroidissement', 'Cooling'],
          ['Power Supply Replacement', "Remplacement du bloc d'alimentation"],
          ['Motherboard Replacement', 'Remplacement de carte mère'],
          ['Case Swap', 'Changement de boîtier'],
          ['Fan Installation', 'Installation de ventilateurs'],
        ],
      },
      {
        en: 'Tuning and finishing',
        fr: 'Réglages et finition',
        promptEn: 'All right. Which tuning or finishing service do you need?',
        promptFr: 'D\u2019accord. Quel r\u00e9glage ou quelle finition vous int\u00e9resse?',
        services: [
          ['Cable Management', 'Gestion des câbles'],
          ['RAM Overclocking (XMP/EXPO)', 'Overclocking', 'Overclocking'],
        ],
      },
      {
        en: 'Maintenance',
        fr: 'Nettoyage / Entretien',
        promptEn: 'All right. What kind of maintenance do you need?',
        promptFr: 'D\u2019accord. Quel entretien vous int\u00e9resse?',
        services: [
          ['Professional PC Cleaning', 'Nettoyage professionnel de PC'],
          ['Thermal Paste Replacement', 'Remplacement de pâte thermique'],
          ['Annual Tune-Up', 'Entretien annuel'],
        ],
      },
    ];

    function choiceLabel(item) {
      return fr ? item.fr : item.en;
    }

    function showContactLink() {
      clearQuick();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (fr ? '/fr/' : '/');
      if (root.charAt(root.length - 1) !== '/') root += '/';
      var wrap = document.createElement('div');
      wrap.className = 'ejs-sbk-quick-wrap';
      var link = document.createElement('a');
      link.className = 'ejs-sbk-quick-btn';
      link.href = root + 'pages/contact';
      link.textContent = copy.contactForm;
      wrap.appendChild(link);
      msgsEl.insertBefore(wrap, typingEl);
      quickEl = wrap;
      scroll();
    }

    function showChoices(buttons) {
      clearQuick();
      if (booked || !buttons.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'ejs-sbk-quick-wrap';
      wrap.setAttribute('role', 'group');
      buttons.forEach(function (item) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ejs-sbk-quick-btn' + (item.other ? ' ejs-sbk-quick-other' : '');
        btn.textContent = item.label;
        btn.style.whiteSpace = 'normal';
        btn.addEventListener('click', item.onClick);
        wrap.appendChild(btn);
      });
      msgsEl.insertBefore(wrap, typingEl);
      quickEl = wrap;
      scroll();
    }

    function showCategories() {
      if (cfg.bookingSent || booked) return;
      var buttons = serviceChoices.map(function (group) {
        return {
          label: choiceLabel(group),
          onClick: function () {
            var label = choiceLabel(group);
            var phrase = fr ? group.promptFr : group.promptEn;
            addMsg('user', label);
            messages.push({ role: 'user', content: label });
            addMsg('ai', phrase);
            messages.push({ role: 'assistant', content: phrase });
            showServices(group);
          },
        };
      });
      buttons.push({
        label: fr ? 'Je ne sais pas' : 'Not sure',
        other: true,
        onClick: function () {
          send(fr ? 'Je ne sais pas quel service choisir.' : "I'm not sure which service I need.", null, false);
        },
      });
      showChoices(buttons);
    }

    function showServices(group) {
      var buttons = group.services.map(function (pair) {
        var label = fr ? pair[1] : (pair[2] || pair[0]);
        return {
          label: label,
          onClick: function () {
            rememberService(label);
            if (draft.device) send(copy.service + label, null, false);
            else askDeviceThen(copy.service + label);
          },
        };
      });
      buttons.push({
        label: fr ? 'Retour' : 'Back',
        other: true,
        onClick: function () {
          showCategories();
        },
      });
      showChoices(buttons);
    }

    function clearQuick() {
      if (quickEl && quickEl.parentNode) quickEl.parentNode.removeChild(quickEl);
      quickEl = null;
    }

    function clearPanel() {
      if (summarySlot) {
        summarySlot.classList.remove('ejs-sbk-show');
        summarySlot.innerHTML = '';
      }
      if (panelEl && panelEl !== summarySlot && panelEl.parentNode) panelEl.parentNode.removeChild(panelEl);
      panelEl = null;
    }

    function applyDraft(next) {
      if (!next || typeof next !== 'object') return;
      ['service', 'category', 'device', 'details', 'date', 'time', 'name', 'email', 'phone'].forEach(function (key) {
        if (next[key]) draft[key] = next[key];
      });
    }

    function rememberService(label) {
      serviceChoices.forEach(function (group) {
        group.services.forEach(function (pair) {
          if (pair[0] === label || pair[1] === label || pair[2] === label) {
            draft.service = pair[0];
            draft.category = group.en;
          }
        });
      });
    }

    function contactMissing() {
      return !draft.name || !draft.email || !draft.phone;
    }

    function shopDay(offset) {
      var today = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
      var utc = new Date(today + 'T12:00:00Z');
      utc.setUTCDate(utc.getUTCDate() + offset);
      return utc.toISOString().slice(0, 10);
    }

    function weekdayOf(ymd) {
      return new Date(ymd + 'T12:00:00Z').getUTCDay();
    }

    function formatSlot(slot) {
      var ymd = slot.date;
      var time = slot.time;
      var today = shopDay(0);
      var tomorrow = shopDay(1);
      var displayDate = ymd;
      if (ymd === today) displayDate = copy.today;
      else if (ymd === tomorrow) displayDate = copy.tomorrow;
      else {
        displayDate = new Date(ymd + 'T12:00:00Z').toLocaleDateString(fr ? 'fr-CA' : 'en-CA', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          timeZone: 'UTC',
        });
      }
      var hour = parseInt(time.slice(0, 2), 10);
      var minute = time.slice(3, 5);
      var displayTime = fr
        ? hour + '\u00a0h\u00a0' + minute
        : (hour % 12 || 12) + ':' + minute + (hour >= 12 ? ' PM' : ' AM');
      return {
        date: ymd,
        time: time,
        label: displayDate + '\n' + displayTime,
      };
    }

    function loadOpenSlots(query) {
      var base = String(cfg.bookingApiUrl || '').replace(/\/$/, '');
      return fetch(base + '/api/services/availability?' + query)
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || !Array.isArray(data)) throw new Error('availability');
            return data.map(formatSlot);
          });
        });
    }

    function showDayChoices() {
      var today = shopDay(0);
      var dow = weekdayOf(today);
      var buttons = [
        { label: copy.today, query: 'preferredDay=' + today },
        { label: copy.tomorrow, query: 'preferredDay=' + shopDay(1) },
      ];
      if (dow >= 1 && dow <= 5) {
        var untilFriday = 5 - dow;
        buttons.push({
          label: copy.thisWeek,
          query: 'dayStart=' + today + '&dayEnd=' + shopDay(untilFriday) + '&limit=40',
        });
      }
      var untilNextMonday = (8 - dow) % 7 || 7;
      buttons.push({
        label: copy.nextWeek,
        query: 'dayStart=' + shopDay(untilNextMonday) + '&dayEnd=' + shopDay(untilNextMonday + 4) + '&limit=40',
      });
      showChoices(
        buttons.map(function (item) {
          return {
            label: item.label,
            onClick: function () {
              if (busy) return;
              addMsg('user', item.label);
              messages.push({ role: 'user', content: item.label });
              var day = item.label.charAt(0).toLowerCase() + item.label.slice(1);
              var phrase = copy.dayChosen.replace('{day}', day);
              addMsg('ai', phrase);
              messages.push({ role: 'assistant', content: phrase });
              busy = true;
              clearQuick();
              showTyping(true);
              setEnabled(false);
              loadOpenSlots(item.query)
                .then(function (slots) {
                  busy = false;
                  showTyping(false);
                  setEnabled(true);
                  if (!slots.length) {
                    addMsg('ai', copy.noSlots);
                    showDayChoices();
                    return;
                  }
                  showPeriodChoices(slots);
                })
                .catch(function () {
                  busy = false;
                  showTyping(false);
                  setEnabled(true);
                  addMsg('ai', copy.network);
                  showDayChoices();
                });
            },
          };
        })
      );
    }

    function showPeriodChoices(slots) {
      function hours(slot) {
        return parseInt(slot.time.slice(0, 2), 10);
      }
      var groups = [
        { label: copy.morning, match: function (slot) { return hours(slot) < 12; } },
        { label: copy.afternoon, match: function (slot) { return hours(slot) >= 12; } },
        { label: copy.anytime, match: function () { return true; } },
      ];
      showChoices(
        groups
          .filter(function (group) {
            return slots.some(group.match);
          })
          .map(function (group) {
            return {
              label: group.label,
              onClick: function () {
                addMsg('user', group.label);
                messages.push({ role: 'user', content: group.label });
                addMsg('ai', copy.timeChosen);
                messages.push({ role: 'assistant', content: copy.timeChosen });
                renderSlots(slots.filter(group.match), true);
              },
            };
          })
          .concat([
            {
              label: fr ? 'Retour' : 'Back',
              other: true,
              onClick: function () {
                addMsg('ai', copy.otherDay);
                messages.push({ role: 'assistant', content: copy.otherDay });
                showDayChoices();
              },
            },
          ])
      );
    }

    function renderSlots(slots, fromSchedule) {
      clearQuick();
      if (!slots || !slots.length || booked) return;
      var wrap = document.createElement('div');
      wrap.className = 'ejs-sbk-quick-wrap ejs-sbk-slot-wrap';
      wrap.setAttribute('role', 'group');
      slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ejs-sbk-quick-btn ejs-sbk-slot-btn';
        btn.textContent = slot.label || slot.displayTime || slot.time;
        btn.addEventListener('click', function () {
          if (busy || booked) return;
          var label = String(slot.label || slot.time).replace(/\n/g, ' ');
          draft.date = slot.date;
          draft.time = slot.time;
          clearQuick();
          addMsg('user', copy.choose + ' ' + label);
          messages.push({ role: 'user', content: copy.choose + ' ' + label });
          var ack = copy.slotOk.replace('{when}', label);
          addMsg('ai', ack);
          messages.push({ role: 'assistant', content: ack });
          if (contactMissing()) renderContact();
          else renderConfirm();
        });
        wrap.appendChild(btn);
      });
      if (fromSchedule) {
        var another = document.createElement('button');
        another.type = 'button';
        another.className = 'ejs-sbk-quick-btn ejs-sbk-quick-other';
        another.textContent = copy.anotherDay;
        another.addEventListener('click', function () {
          addMsg('ai', copy.otherDay);
          messages.push({ role: 'assistant', content: copy.otherDay });
          showDayChoices();
        });
        wrap.appendChild(another);
      } else if (slots.length >= 8) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'ejs-sbk-quick-btn ejs-sbk-quick-other';
        more.textContent = copy.more;
        more.addEventListener('click', function () {
          send(copy.moreMsg, null, false);
        });
        wrap.appendChild(more);
      }
      msgsEl.insertBefore(wrap, typingEl);
      quickEl = wrap;
      scroll();
    }

    function fieldError(input, message) {
      input.classList.toggle('ejs-sbk-invalid', !!message);
      var note = input.parentNode.querySelector('.ejs-sbk-field-error');
      if (!note) {
        note = document.createElement('span');
        note.className = 'ejs-sbk-field-error';
        input.parentNode.appendChild(note);
      }
      note.textContent = message || '';
    }

    function watchField(input) {
      input.addEventListener('input', function () {
        fieldError(input, '');
      });
    }

    function validEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email) && email.indexOf('..') === -1;
    }

    function validPhone(phone) {
      var digits = String(phone || '').replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
    }

    function contactValues(panel) {
      var firstEl = panel.querySelector('[name="first"]');
      var lastEl = panel.querySelector('[name="last"]');
      var emailEl = panel.querySelector('[name="email"]');
      var phoneEl = panel.querySelector('[name="phone"]');
      var first = firstEl.value.trim();
      var last = lastEl.value.trim();
      var email = emailEl.value.trim();
      var phone = phoneEl.value.trim();
      fieldError(firstEl, first ? '' : copy.missingField);
      fieldError(lastEl, last ? '' : copy.missingField);
      fieldError(emailEl, !email ? copy.missingField : validEmail(email) ? '' : copy.badEmail);
      fieldError(phoneEl, !phone ? copy.missingField : validPhone(phone) ? '' : copy.badPhone);
      return {
        ok: !!(first && last && validEmail(email) && validPhone(phone)),
        first: first,
        last: last,
        email: email,
        phone: phone,
      };
    }

    function slotRefusal(part) {
      return /cr[ée]neau|autre jour|autre heure|another day|another time|time slot|ne peux pas vous proposer|cannot offer|can't offer|plus disponible|no longer available/i.test(part);
    }

    function dropSlotRefusal(reply) {
      if (!reply || !draft.date || !draft.time) return reply;
      return String(reply)
        .split(/\n+/)
        .filter(function (part) {
          return part.trim() && !slotRefusal(part);
        })
        .join('\n\n')
        .trim();
    }

    function renderContact() {
      clearPanel();
      if (booked) return;
      var fillSaid = messages.some(function (message) {
        return message.role === 'assistant' && message.content === copy.fillForm;
      });
      if (!fillSaid) {
        addMsg('ai', copy.fillForm);
        messages.push({ role: 'assistant', content: copy.fillForm });
      }
      var panel = document.createElement('div');
      panel.className = 'ejs-sbk-contact-panel';
      panel.innerHTML =
        '<form class="ejs-sbk-contact-form" novalidate>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.first) +
        '</label><input type="text" name="first" required autocomplete="given-name" placeholder="' +
        esc(copy.hintFirst) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.last) +
        '</label><input type="text" name="last" required autocomplete="family-name" placeholder="' +
        esc(copy.hintLast) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.email) +
        '</label><input type="email" name="email" required autocomplete="email" placeholder="' +
        esc(copy.hintEmail) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.phone) +
        '</label><input type="tel" name="phone" required autocomplete="tel" placeholder="' +
        esc(copy.hintPhone) +
        '"></div>' +
        '<button type="submit" class="ejs-sbk-contact-submit">' +
        esc(copy.continue) +
        '</button></form>';
      msgsEl.insertBefore(panel, typingEl);
      panelEl = panel;
      scroll();
      panel.querySelectorAll('input').forEach(watchField);
      var firstField = panel.querySelector('input');
      if (firstField) firstField.focus();
      panel.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy) return;
        var values = contactValues(panel);
        if (!values.ok) return;
        var first = values.first;
        var last = values.last;
        var email = values.email;
        var phone = values.phone;
        draft.name = first + ' ' + last;
        draft.email = email;
        draft.phone = phone;
        clearPanel();
        renderConfirm();
      });
    }

    function catalogLabel(englishName, kind) {
      var found = englishName || '';
      serviceChoices.forEach(function (group) {
        if (kind === 'category' && group.en === englishName) found = fr ? group.fr : group.en;
        group.services.forEach(function (pair) {
          if (kind === 'service' && (pair[0] === englishName || pair[2] === englishName)) found = fr ? pair[1] : (pair[2] || pair[0]);
          if (kind === 'category' && pair[0] === englishName) found = fr ? group.fr : group.en;
        });
      });
      return found || copy.summaryNa;
    }

    function deviceLabel(value) {
      if (!value) return copy.summaryNa;
      if (/desktop/i.test(value)) return fr ? 'Ordinateur de bureau' : 'Desktop PC';
      return value;
    }

    function summaryWhen() {
      if (!draft.date || !draft.time) return { date: copy.summaryNa, time: copy.summaryNa };
      var slot = formatSlot({ date: draft.date, time: draft.time });
      var parts = String(slot.label || '').split('\n');
      return { date: parts[0] || copy.summaryNa, time: parts[1] || draft.time };
    }

    function summaryRow(label, value) {
      return '<div class="ejs-sbk-summary-item"><dt>' + esc(label) + '</dt><dd>' + esc(value || copy.summaryNa) + '</dd></div>';
    }

    function markSummaryConfirmed() {
      var actions = summarySlot && summarySlot.querySelector('.ejs-sbk-summary-actions');
      if (!actions) return;
      actions.innerHTML = '<div class="ejs-sbk-confirmed" role="status">\u2705 ' + esc(copy.appointmentRequested) + '</div>';
    }

    function paintSummary(priceText) {
      if (!summarySlot || booked) return;
      var when = summaryWhen();
      var notes = [copy.priceNote1, copy.priceNote2, copy.priceNote3, copy.priceNote4];
      var notesHtml = '<ul class="ejs-sbk-summary-price-notes">';
      notes.forEach(function (note) {
        notesHtml +=
          '<li class="ejs-sbk-summary-price-note"><span class="ejs-sbk-summary-price-note-icon"></span><span class="ejs-sbk-summary-price-note-text">' +
          esc(note) +
          '</span></li>';
      });
      notesHtml += '</ul>';
      summarySlot.innerHTML =
        '<div class="ejs-sbk-summary"><div class="ejs-sbk-summary-inner">' +
        '<h3 class="ejs-sbk-summary-title">' + esc(copy.summaryTitle) + '</h3>' +
        '<p class="ejs-sbk-summary-note">' + esc(copy.summaryNote) + '</p>' +
        '<dl class="ejs-sbk-summary-grid">' +
        summaryRow(copy.summaryCategory, catalogLabel(draft.category || draft.service, 'category')) +
        summaryRow(copy.summaryService, catalogLabel(draft.service, 'service')) +
        summaryRow(copy.summaryDevice, deviceLabel(draft.device)) +
        summaryRow(copy.summaryDetails, draft.details) +
        summaryRow(copy.summaryAppointmentType, copy.dropOff) +
        summaryRow(copy.summaryDate, when.date) +
        summaryRow(copy.summaryTime, when.time) +
        summaryRow(copy.summaryName, draft.name) +
        summaryRow(copy.summaryEmail, draft.email) +
        summaryRow(copy.summaryPhone, draft.phone) +
        '</dl>' +
        '<div class="ejs-sbk-summary-price"><div class="ejs-sbk-summary-item ejs-sbk-summary-item-price"><dt>' +
        esc(copy.summaryEstimatedPrice) +
        '</dt><dd class="ejs-sbk-summary-price-value">' +
        esc(priceText || copy.quoteOnInspection) +
        '</dd></div>' +
        notesHtml +
        '</div><div class="ejs-sbk-summary-actions">' +
        '<button type="button" class="ejs-sbk-btn ejs-sbk-btn-submit" id="ejsSbkSubmitRequest">' +
        esc(copy.requestAppointment) +
        '</button></div></div></div>';
      summarySlot.classList.add('ejs-sbk-show');
      msgsEl.insertBefore(summarySlot, typingEl);
      panelEl = summarySlot;
      var button = summarySlot.querySelector('#ejsSbkSubmitRequest');
      if (button) {
        button.addEventListener('click', function () {
          if (busy || booked) return;
          button.disabled = true;
          button.textContent = copy.requesting;
          send('', null, true);
        });
      }
      scroll();
    }

    function renderConfirm() {
      if (booked) return;
      if (!draft.details) {
        var detailMsg = messages
          .filter(function (message) { return message.role === 'user'; })
          .map(function (message) { return message.content; })
          .reverse()
          .find(function (text) {
            return text.length >= 8 && !/^(C'est un|Je choisis|I choose|It's a|This is a)/i.test(text);
          });
        if (detailMsg) draft.details = detailMsg;
      }
      clearQuick();
      if (!messages.length || messages[messages.length - 1].content !== copy.summaryPrompt) {
        addMsg('ai', copy.summaryPrompt);
        messages.push({ role: 'assistant', content: copy.summaryPrompt });
      }
      var service = draft.service;
      var base = String(cfg.bookingApiUrl || '').replace(/\/$/, '');
      var request = service
        ? fetch(base + '/api/services/pricing?service=' + encodeURIComponent(service) + '&lang=' + lang)
            .then(function (response) {
              return response.ok ? response.json() : null;
            })
            .catch(function () {
              return null;
            })
        : Promise.resolve(null);
      var assemblyPrices = {
        'PC Assembly': fr ? '70 $ CAD' : '$70 CAD',
        'PC Assembly with Liquid Cooler': fr ? '100 $ CAD' : '$100 CAD',
        'PC Assembly Compact Case': fr ? '100 $ CAD' : '$100 CAD',
        'PC Assembly Compact Case with Liquid Cooler': fr ? '130 $ CAD' : '$130 CAD',
      };
      request.then(function (entry) {
        if (booked) return;
        paintSummary((entry && entry.summaryPriceLabelDisplay) || assemblyPrices[draft.service]);
      });
    }

    function isLaptopText(value) {
      return /\blaptops?\b|\bnotebooks?\b|\bmacbooks?\b|chromebook|portable/i.test(String(value || ''));
    }

    function customerChoseLaptop() {
      var laptop = false;
      messages.forEach(function (message) {
        if (message.role !== 'user') return;
        if (isLaptopText(message.content)) laptop = true;
        if (/\bdesktop\b|ordinateur de bureau|pc de bureau/i.test(message.content)) laptop = false;
      });
      return laptop;
    }

    function showDeviceChoices() {
      if (cfg.bookingSent || booked || draft.device || customerChoseLaptop()) return;
      showChoices([
        {
          label: copy.desktop,
          onClick: function () {
            send(copy.desktopMsg, { device: 'Desktop PC' }, false);
          },
        },
        {
          label: copy.laptop,
          onClick: function () {
            refuseLaptop();
          },
        },
      ]);
    }

    function askDeviceThen(userText) {
      if (busy || booked) return;
      clearQuick();
      clearPanel();
      addMsg('user', userText);
      messages.push({ role: 'user', content: userText });
      addMsg('ai', copy.deviceAsk);
      messages.push({ role: 'assistant', content: copy.deviceAsk });
      showDeviceChoices();
    }

    function showLaptopFollowUp() {
      if (booked) return;
      if (!laptopOffered) {
        laptopOffered = true;
        addMsg('ai', copy.laptopNext);
        messages.push({ role: 'assistant', content: copy.laptopNext });
      }
      showChoices([
        {
          label: copy.desktopInstead,
          onClick: function () {
            send(copy.desktopMsg, { device: 'Desktop PC' }, false);
          },
        },
        {
          label: copy.leaveInfo,
          onClick: function () {
            renderLaptopLead();
          },
        },
      ]);
    }

    function renderLaptopLead() {
      clearQuick();
      clearPanel();
      if (booked) return;
      var panel = document.createElement('div');
      panel.className = 'ejs-sbk-contact-panel';
      panel.innerHTML =
        '<form class="ejs-sbk-contact-form" novalidate>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.first) +
        '</label><input type="text" name="first" required autocomplete="given-name" placeholder="' +
        esc(copy.hintFirst) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.last) +
        '</label><input type="text" name="last" required autocomplete="family-name" placeholder="' +
        esc(copy.hintLast) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.email) +
        '</label><input type="email" name="email" required autocomplete="email" placeholder="' +
        esc(copy.hintEmail) +
        '"></div>' +
        '<div class="ejs-sbk-form-row"><label>' +
        esc(copy.phone) +
        '</label><input type="tel" name="phone" required autocomplete="tel" placeholder="' +
        esc(copy.hintPhone) +
        '"></div>' +
        '<div class="ejs-sbk-form-row" style="grid-column:1/-1"><label>' +
        esc(copy.note) +
        '</label><input type="text" name="note" maxlength="500" placeholder="' +
        esc(copy.hintNote) +
        '"></div>' +
        '<button type="submit" class="ejs-sbk-contact-submit">' +
        esc(copy.leadSend) +
        '</button></form>';
      msgsEl.insertBefore(panel, typingEl);
      panelEl = panel;
      scroll();
      panel.querySelectorAll('input').forEach(watchField);
      var firstField = panel.querySelector('input');
      if (firstField) firstField.focus();
      panel.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy) return;
        var values = contactValues(panel);
        if (!values.ok) return;
        var first = values.first;
        var last = values.last;
        var email = values.email;
        var phone = values.phone;
        var note = panel.querySelector('[name="note"]').value.trim();
        busy = true;
        setEnabled(false);
        fetch(String(cfg.bookingApiUrl || '').replace(/\/$/, '') + '/api/services/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lang: lang,
            kind: 'laptop',
            name: first + ' ' + last,
            email: email,
            phone: phone,
            note: note,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok && data && data.ok };
            });
          })
          .then(function (result) {
            busy = false;
            setEnabled(true);
            clearPanel();
            addMsg('ai', result.ok ? copy.leadThanks : copy.leadFail);
          })
          .catch(function () {
            busy = false;
            setEnabled(true);
            clearPanel();
            addMsg('ai', copy.leadFail);
          });
      });
    }

    function refuseLaptop() {
      if (busy || booked) return;
      clearQuick();
      clearPanel();
      addMsg('user', copy.laptopMsg);
      messages.push({ role: 'user', content: copy.laptopMsg });
      addMsg('ai', copy.laptopNo);
      messages.push({ role: 'assistant', content: copy.laptopNo });
      showLaptopFollowUp();
    }

    function send(text, patch, confirm) {
      var trimmed = String(text || '').trim();
      if (busy || booked) return;
      if (listening) haltMic();
      if (!trimmed && !confirm) return;
      if (!cfg.bookingApiUrl) {
        addMsg('ai', copy.network);
        return;
      }
      if (patch) {
        Object.keys(patch).forEach(function (key) {
          if (patch[key]) draft[key] = patch[key];
        });
      }
      clearQuick();
      if (!confirm) clearPanel();
      if (trimmed) {
        addMsg('user', trimmed);
        messages.push({ role: 'user', content: trimmed });
      }
      inputEl.value = '';
      busy = true;
      setEnabled(false);
      showTyping(true);

      fetch(apiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lang: lang,
          messages: messages,
          draft: draft,
          confirm: !!confirm,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          busy = false;
          showTyping(false);
          var data = result.data || {};
          if (!result.ok && !data.reply) {
            messages.pop();
            setEnabled(true);
            addMsg('ai', copy.network);
            return;
          }
          applyDraft(data.draft);
          if (customerChoseLaptop()) {
            draft.device = null;
            draft.date = null;
            draft.time = null;
          }
          if (data.reply && !(data.booking && data.booking.success)) {
            var reply = dropSlotRefusal(data.reply);
            if (reply && needsVoiceHint() && !/micro/i.test(reply)) {
              reply = reply.replace(/\s*$/, '') + '\n\n' + copy.voiceHint;
              voiceHintShown = true;
            }
            if (reply) {
              addMsg('ai', reply);
              messages.push({ role: 'assistant', content: reply });
            }
          }
          if (data.booking && data.booking.success) {
            booked = true;
            setEnabled(false);
            clearQuick();
            markSummaryConfirmed();
            var success = data.booking.confirmationEmailSent ? copy.successBoth : copy.successCalendar;
            addMsg('ai', success);
            messages.push({ role: 'assistant', content: success });
            return;
          }
          if (confirm) clearPanel();
          setEnabled(true);
          if (data.handoff === 'contact') {
            showContactLink();
            return;
          }
          if (customerChoseLaptop()) {
            showLaptopFollowUp();
            return;
          }
          if (data.readyToConfirm) renderConfirm();
          else if (data.askContact || (draft.date && draft.time && contactMissing())) renderContact();
          else if (data.askDevice && !draft.device && !customerChoseLaptop()) {
            inputEl.focus();
            showDeviceChoices();
          }
          else if (!draft.date && (data.askSchedule || (data.slots && data.slots.length))) {
            inputEl.focus();
            showDayChoices();
          } else {
            inputEl.focus();
            renderSlots(data.slots);
          }
        })
        .catch(function () {
          busy = false;
          showTyping(false);
          if (messages.length && messages[messages.length - 1].role === 'user') messages.pop();
          setEnabled(true);
          addMsg('ai', copy.network);
        });
    }

    function reset() {
      messages = [];
      draft = emptyDraft();
      busy = false;
      booked = false;
      laptopOffered = false;
      voiceHintShown = false;
      haltMic();
      clearQuick();
      clearPanel();
      Array.prototype.slice.call(msgsEl.querySelectorAll('.ejs-sbk-msg')).forEach(function (node) {
        node.parentNode.removeChild(node);
      });
      inputEl.value = '';
      setEnabled(true);
      addMsg('ai', cfg.bookingSent ? copy.sent : copy.greet);
      showCategories();
    }

    if (micBtn) {
      micBtn.addEventListener('click', function () {
        if (busy || booked) return;
        if (listening) {
          var text = String(inputEl.value || spoken || '').trim();
          haltMic();
          if (text) {
            inputEl.value = text;
            send(text, null, false);
          }
          return;
        }
        startListening();
      });
    }
    sendBtn.addEventListener('click', function () {
      send(inputEl.value, null, false);
    });
    inputEl.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        send(inputEl.value, null, false);
      }
    });
    if (resetBtn) resetBtn.addEventListener('click', reset);

    var cardLock = false;
    document.querySelectorAll('.ejs-svc-service-link[data-service]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        event.preventDefault();
        if (cardLock || busy || booked) return;
        var name = card.getAttribute('data-service');
        if (!name) return;
        rememberService(name);
        cardLock = true;
        var section = document.getElementById('ejs-svc-booking');
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          cardLock = false;
          if (draft.device) send(copy.service + name, null, false);
          else askDeviceThen(copy.service + name);
        }, 350);
      });
    });

    addMsg('ai', cfg.bookingSent ? copy.sent : copy.greet);
    showCategories();
    setEnabled(true);
  });
})();
